import { IDatabaseConfig } from '../../../../../apps/idl/src/model/store/IDatabaseConfig';
import { IStoreDocument } from '../../../../../apps/idl/src/model/store/IStoreDocument';
import { ILoggerConfig } from './ILoggerConfig';

export interface IConfApp extends IStoreDocument {

	/** Type du document. */
	type: string;
	/** Tableau des bases de données à répliquer. */
	databases: Array<IDatabaseConfig>;
	/** Tableau des bases de données des espaces de travail. */
	workspaceDatabases: Array<IDatabaseConfig>;
	/** Configuration du logging */
	logger: ILoggerConfig;
}